import { DeliveryFilterParams } from "@/types";

export const authApiUrl = {
  login: '/auth/rider/login',
  register: '/auth/rider/register',
  requestOtp: '/auth/rider/request-otp',
  loginOtp: '/auth/rider/login-otp',
  forgotPassword: '/auth/rider/forgot-password',
  resetPassword: '/auth/rider/reset-password',
  onboarding: '/auth/rider/complete-onboarding',
  uploadDoc: '/auth/rider/upload-document',
  verificationStatus(riderId: string){
    return `/auth/rider/verification-status/${riderId}`;
  },
  refresh: '/auth/refresh'
};

export const profileApiUrl = {
  profile: '/rider/profile',
  updateStatus: '/rider/profile/status'
}

export const dashboardApiUrl = {
  incentives: '/rider/dashboard/incentives',
  earnings: '/rider/dashboard/earnings',
  deliveries(params?: DeliveryFilterParams){
    let url = '/rider/deliveries?'
    if (params?.status) url = `${url}status=${params?.status}&`
    if (params?.dateFrom) url = `${url}dateFrom=${params?.dateFrom}&`
    if (params?.dateTo) url = `${url}dateTo=${params?.dateTo}&`
    return url
  },
  earningsLive: '/rider/dashboard/earnings/live',
  weeklySummary: '/rider/dashboard/weekly-summary',
  performance: '/rider/dashboard/performance',
  surge({lat, lng}: { lat: number; lng: number }){
    return `/rider/dashboard/surge/current?lat=${lat}&lng=${lng}`
  }
}

export type InterestEarningsParams = {
  period: 'today'| 'week' | 'month' | 'year' | 'all_time'
}

export const walletApiUrl = {
  current: '/rider/wallets/current',
  transactions: '/rider/wallets/transactions',
  summary: '/rider/wallets/summary',
  interestEarnings(walletId: string, {period}: InterestEarningsParams){
    return `/rider/wallet-interest/earnings/${walletId}?period=${period}`
  },
  interestProjection(days: number){
    return `/rider/wallet-interest/projection?days=${days}`
  },
  bankAccounts: '/rider/enhanced-payouts/bank-accounts',
  updateBankAccount(accountId: string){
    return `/rider/enhanced-payouts/bank-accounts/${accountId}/primary`
  },
  deleteBankAccount(accountId: string) {
    return `/rider/enhanced-payouts/bank-accounts/${accountId}`
  },
  autoWithdrawal: '/rider/enhanced-payouts/auto-withdrawal',
  scheduledPayout: '/rider/enhanced-payouts/scheduled',
  withdraw: '/rider/enhanced-payouts/withdraw',
  dashboard: '/rider/enhanced-payouts/dashboard',
  status: '/rider/enhanced-payouts/daily-status',
  tier: '/rider/tier-rewards/my-tier',
  tierHistory: '/rider/tier-rewards/history',
  availableInstantPayout: '/rider/enhanced-payouts/instant-payouts/availability',
  calculatePayoutFees: '/rider/enhanced-payouts/instant-payouts/calculate-fees',
  instantPayout: '/rider/enhanced-payouts/instant-payouts'
}

export const ordersApiUrl = {
  nearbyOrders: '/rider/location/nearby-orders?radius=500',
  activeOrders: '/rider/deliveries?status=active',
  acceptOrder(orderId: string) {
    return `/rider/orders/${orderId}/accept`
  },
  requestPickupPin(orderId: string) {
    return `/rider/orders/${orderId}/request-pickup-pin`
  },
  startDelivery(orderId: string) {
    return `/rider/orders/${orderId}/start-delivery`
  },
  completeDelivery(orderId: string) {
    return `/rider/orders/${orderId}/complete-delivery`
  }
}

export const emergencyApiUrl = {
  sos: '/rider/sos-alerts',
  triggerSOS: '/rider/emergency/sos',
  emergencyContacts: '/rider/emergency/contacts',
  updateEmergencyContact(contactId: string) {
    return `/rider/emergency/contacts/${contactId}`
  }
}

export const gamificationApiUrl = {
  leaderboards(type: 'weekly' | 'monthly' | 'all_time', region: string, limit: number){
    // Use the new v2 API endpoint
    return `/api/v2/rider/leaderboard?period=${type}&limit=${limit}`
  },
  achievements: '/api/v2/rider/achievements',
  dailyStats(startDate: string, endDate: string) {
    return `/api/v2/rider/daily-stats?startDate=${startDate}&endDate=${endDate}`
  },
  incentiveStatus: '/api/v2/rider/incentive-status',
  badges: '/rider/gamification/badges'
}

export const notificationApiUrl = {
  notifications: '/rider/notifications?limit=50',
  readAll: '/rider/notifications/mark-all-read',
  updateNotification(notificationId: string) {
    return `/rider/notifications/${notificationId}`
  },
}
